import { render, staticRenderFns } from "./ProductImagesCarousel.vue?vue&type=template&id=038ab34e&lang=pug&"
import script from "./ProductImagesCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductImagesCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports